"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableListItem = void 0;
var react_1 = __importStar(require("react"));
var icons_1 = require("../../../constants/icons");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var useOnClickOutside_1 = require("../../../hooks/useOnClickOutside");
var molecules_1 = require("../../molecules");
var DraggableListItem = function (_a) {
    var _b = _a.columnCount, columnCount = _b === void 0 ? 2 : _b, _c = _a.rowCount, rowCount = _c === void 0 ? 3 : _c, index = _a.index, item = _a.item, onDragStart = _a.onDragStart, onDragEnter = _a.onDragEnter, itemClassName = _a.itemClassName, contentClassName = _a.contentClassName, ListItemComponent = _a.ListItemComponent, id = _a.id, eventCallback = _a.eventCallback, onDelete = _a.onDelete, onChange = _a.onChange, showDelete = _a.showDelete, listItemProps = _a.listItemProps, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var columnDots = Array(columnCount).fill('');
    var rowDots = Array(rowCount).fill('');
    var _e = react_1.useState(false), isItemActive = _e[0], setIsItemActive = _e[1];
    var containerRef = react_1.useRef(null);
    var handleDragEnter = function () {
        onDragEnter(index);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.DRAGGABLE_LIST_DRAG_ENTER, { id: id, drag_enter_index: index });
    };
    var handleDragOver = function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
    };
    var handleDragStart = function () {
        onDragStart(index);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.DRAGGABLE_LIST_DRAG_START, { id: id, drag_start_index: index });
    };
    var handleItemActive = function () {
        setIsItemActive(true);
    };
    var handleItemInActive = function () {
        setIsItemActive(false);
    };
    useOnClickOutside_1.useOnClickOutside(containerRef, handleItemInActive);
    return (react_1.default.createElement("div", { ref: containerRef, className: "tw-flex tw-cursor-pointer tw-group " + itemClassName + " " + (item === null || item === void 0 ? void 0 : item.className), onClick: handleItemActive, onMouseLeave: handleItemInActive, draggable: !disabled, onDragStart: handleDragStart, onDragEnter: handleDragEnter, onDragOver: handleDragOver, "data-testid": "draggable-item-" + id },
        react_1.default.createElement("div", { className: 'tw-w-7', "data-testid": "draggable-item-sidebar-" + id },
            react_1.default.createElement("div", { className: 'tw-w-7 tw-h-7 tw-bg-TEXT_PRIMARY tw-text-white f-12-600 tw-flex tw-items-center tw-justify-center', "data-testid": "draggable-item-sidebar-index-" + id }, index + 1),
            react_1.default.createElement("div", { className: 'tw-bg-BASE_PRIMARY tw-flex tw-flex-col tw-gap-[3px] tw-items-center tw-justify-center tw-h-[calc(100%-28px)]', "data-testid": "draggable-item-sidebar-dots-container-" + id }, rowDots === null || rowDots === void 0 ? void 0 : rowDots.map(function (_, index) { return (react_1.default.createElement("div", { key: "column_dots_" + index, className: 'tw-flex tw-gap-[3px]', "data-testid": "draggable-item-sidebar-column-dots-" + index + "-" + id }, columnDots === null || columnDots === void 0 ? void 0 : columnDots.map(function (_, index) { return (react_1.default.createElement("div", { className: "tw-w-0.5 tw-h-0.5 tw-rounded-full tw-bg-TEXT_TERTIARY", key: "row_dots_" + index, "data-testid": "draggable-item-sidebar-row-dots-" + index + "-" + id })); }))); }))),
        react_1.default.createElement("div", { className: "tw-p-5 tw-flex-grow tw-relative tw-border-[0.5px] tw-border-l-0 tw-border-DIVIDER_GRAY " + contentClassName, "data-testid": "draggable-item-content-" + id },
            react_1.default.createElement(ListItemComponent, __assign({ data: item, disabled: disabled, onChange: onChange }, listItemProps)),
            showDelete && !isItemActive && !disabled && (react_1.default.createElement("div", { className: 'group-hover:tw-flex tw-absolute tw-z-20 -tw-right-10 -tw-top-[0.5px] tw-w-10 tw-h-10 tw-border tw-border-DIVIDER_GRAY hover:tw-bg-LAVENDER_2 tw-bg-white tw-hidden tw-items-center tw-justify-center', onClick: onDelete, "data-testid": "draggable-item-delete-wrapper-" + id },
                react_1.default.createElement(molecules_1.SvgSpriteLoader, { id: 'trash-01', iconCategory: icons_1.ICON_SPRITE_TYPES.GENERAL, width: 20, height: 20 }))))));
};
exports.DraggableListItem = DraggableListItem;
